import { render, staticRenderFns } from "./EinstellungenRessourcen.vue?vue&type=template&id=5b75cd9b"
import script from "./EinstellungenRessourcen.vue?vue&type=script&lang=js"
export * from "./EinstellungenRessourcen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports